<template>
  <v-flex xs12 sm6 md3 :class="paddingClass">
    <v-autocomplete
      v-model.trim="emailId"
      :search-input.sync="search"
      cache-items
      :loading="isLoading"
      :items="emails"
      item-text="value"
      item-value="id"
      placeholder="Wpisz adres e-mail"
      hide-no-data
      clearable
      flat
      label="Adres e-mail"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import { getEmailFilterList } from '../../../repository/users/index';

export default {
  name: 'filter-by-email',
  data: () => ({
    emailId: null,
    emails: [],
    search: null,
    isLoading: false,
    descriptionLimit: 60,
  }),
  computed: {
    paddingClass() {
      return this.$vuetify.breakpoint.xs ? 'pr-0' : 'pr-3';
    },
  },
  methods: {
    async getFilterList(searchValue) {
      this.isLoading = true;
      try {
        const emailFilterList = await getEmailFilterList({ name: searchValue });
        this.isLoading = false;
        this.emails = emailFilterList.data.data.items;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getFilterList();
  },
  watch: {
    search(val) {
      const isInList = this.emails.find(item => item.value === val);
      if (val && !isInList) {
        this.getFilterList(val);
      }
    },
    emailId(email) {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      if (email) {
        newQuery.email = email;
      } else {
        delete newQuery.email;
      }
      this.$router.push({ path: '/uzytkownicy/1', query: newQuery });
    },
  },
};
</script>
